module.exports = __webpack_public_path__ + "static/media/src.a2690066.jpg";